/**
 * Created by jv on 03/02/2017.
 */
const utils = require("Sources/utils/utils");
const ElementCreator = require("Sources/components/element-creator");
const InputSpinner = require("Sources/components/input-spinner");
const Tooltip = require("Sources/components/tooltip");
require("script-loader!Libs/bootstrap-datepicker/js/bootstrap-datepicker.min.js");

require("Libs/bootstrap-datepicker/css/bootstrap-datepicker3.min.css");
require("Styles/components/form-group.scss");

module.exports = class FormGroupTemplate
{
  constructor(options)
  {
    /*
     * options.key
     * options.dataGroup
     * options.inputId
     *
     * options.appendTo
     * options.label ( null or undefined for no label)
     * options.inline (true | false)
     *
     * options.formGroupClasses
     * options.labelClasses
     * options.inputClasses
     * options.inputErrorClass
     *
     * options.initialValue
     * options.required
     * options.inputType (text | number | range | select | password | textarea)
     * options.inputOptions (if inputType === select)
     * options.inputAttributes (eg. [ { name: 'max-length', value: 10 } ] )
     *
     * options.inputOptionsValueField (only used for "select" inputType)
     * options.inputOptionsDisplayField (only used for "select" inputType)
     *
     *
     * options.inputHTML
     *
     * options.validator
     * options.onInputChange
     */

    if(utils.isNull(options))
    {
      throw "options must be defined";
    }

    if(utils.isNullOrEmpty(options.key))
    {
      throw "Key cannot be null or empty";
    }

    this.key = options.key;
    this.dataGroup = options.dataGroup;

    this.inputId = utils.isNullOrEmpty(options.inputId) ? this.key.toLowerCase() + "-" + utils.generateUIDShort() : options.inputId;

    this.appendTo = $(options.appendTo);
    this.label = options.label;
    this.labelTooltipTitle = options.labelTooltipTitle;
    this.labelTooltipText = options.labelTooltipText;
    this.labelTooltipPlacement = options.labelTooltipPlacement;
    this.labelTooltipClasses = utils.isArray(options.labelTooltipClasses) ? options.labelTooltipClasses : [];
    this.placeholder = options.placeholder;
    this.inline = options.inline;
    this.disabled = utils.isBoolean(options.disabled) ? options.disabled : false;

    this.formGroupClasses = utils.isArray(options.formGroupClasses) ? options.formGroupClasses : [];
    this.labelClasses = utils.isArray(options.labelClasses) ? options.labelClasses : [];
    this.inputClasses = utils.isArray(options.inputClasses) ? options.inputClasses : [];
    this.inputErrorClass = utils.isNotNull(options.inputErrorClass) ? options.inputErrorClass : "input-error";

    this.displayValue = options.displayValue;
    this.initialValue = options.initialValue;
    this.required = utils.isBoolean(options.required) ? options.required : false;
    this.value = this.initialValue;
    this.inputType = options.inputType;
    this.groupName = options.groupName;
    this.inputOptions = options.inputOptions;
    this.inputAttributes = utils.isArray(options.inputAttributes) ? options.inputAttributes : [];

    this.inputOptionsValueField = utils.isNotNull(options.inputOptionsValueField) ? options.inputOptionsValueField : "value";
    this.inputOptionsDisplayField = utils.isNotNull(options.inputOptionsDisplayField) ? options.inputOptionsDisplayField : "displayText";

    this.dateOptions = utils.isNotNull(options.dateOptions) ? options.dateOptions : {};

    this.inputHTML = options.inputHTML;

    this.afterRender = options.afterRender;
    this.validator = options.validator;
    this.onInputChange = options.onInputChange;

    this.create();
  }

  getInputValue()
  {
    return $("#" + this.inputId)[0].value;
  }

  set value(val)
  {
    this._value = val;

    if(utils.isNotNull(this.inputEl) && this.inputEl.length)
    {
      if(this.inputType === "checkbox")
      {
        this.inputEl.prop("checked", this.value);
      }
      else
      {
        this.inputEl.val(this.value);
      }
    }
  }

  get value()
  {
    return this._value;
  }

  getNewVal()
  {
    if(utils.isNotNull(this.inputEl) && this.inputEl.length)
    {
      this._value = this.inputEl.is(":checked");
    }
  }

  create()
  {
    if(this.initialized !== true)
    {
      var classNames = [ "form-group" ].concat(this.formGroupClasses);

      if(this.inline === true && utils.isNotNull(this.label))
      {
        classNames.splice(1, 0, "form-inline");
      }

      this.formGroupEl = $(ElementCreator.createStringElement({
        classNames: classNames
      }));

      this.renderLabel();
      this.renderInput();

      this.addToDOM();

      this.setUpEventListeners();

      this._initialized = true;
    }
  }

  setUpEventListeners()
  {
    var that = this;
    if(utils.isNotNull(that.inputEl) && that.inputEl.length)
    {
      that.inputEl.on("change", function(e)
      {
        var thisEl = $(this);
        var tmpVal = thisEl.val();

        if(that.inputType === "checkbox" || that.inputType === "radio")
        {
          tmpVal = thisEl.is(":checked");
        }
        else if(that.inputType === "number")
        {
          tmpVal = utils.stringToInt(tmpVal);
          utils.devLog(tmpVal);
        }

        that._value = tmpVal;
        that.validate();

        if(utils.isFunction(that.onInputChange))
        {
          that.onInputChange(that.value, e);
        }
      });

      that.inputEl.on("blur", function(e)
      {
        var thisEl = $(this);
        var tmpVal = thisEl.val();

        if(that.inputType === "checkbox" || that.inputType === "radio")
        {
          tmpVal = thisEl.is(":checked");
        }
        else if(that.inputType === "number")
        {
          tmpVal = utils.stringToInt(tmpVal);
          utils.devLog(tmpVal);
        }

        if(that.value !== tmpVal)
        {
          that._value = tmpVal;
        }

        that.validate();
      });
    }
  }

  reset()
  {
    this.formGroupEl.empty();
    this.renderLabel();
    this.renderInput();
    this.addToDOM();
  }

  validate()
  {
    var isValid = true;

    if(this.required && utils.isNullOrEmpty(this.value))
    {
      isValid = false;
    }

    if(utils.isFunction(this.validator) && isValid)
    {
      isValid = this.validator(this.value);
    }

    if(!isValid && !this.inputEl.hasClass(this.inputErrorClass))
    {
      this.inputEl.addClass(this.inputErrorClass);
    }
    else if(isValid && this.inputEl.hasClass(this.inputErrorClass))
    {
      this.inputEl.removeClass(this.inputErrorClass);
    }

    return isValid;
  }

  renderLabel()
  {
    if(utils.isNull(this.label))
    {
      this.labelEl = null;
      return;
    }

    var classNames = [ "form-label" ].concat(this.labelClasses);

    if(this.inputType === "checkbox" || this.inputType === "radio")
    {
      classNames = this.labelClasses;
    }

    var tooltipEl = "";

    if(!utils.isNullOrEmpty(this.labelTooltipText))
    {
      var tooltipClasses = [ "btn", "btn-icon", "frameless", "question-circle", "form-label-tooltip" ].concat(this.labelTooltipClasses);

      tooltipEl = "<button class='" + tooltipClasses.join(" ") + "' type='button'></button>";
    }

    this.labelEl = ElementCreator.createStringElement({
      tagName: "label",
      classNames: classNames,
      attributes: [
        { name: "for", value: this.inputId }
      ],
      innerHTML: this.label + (this.required ? " <sup>*</sup>" : "") + tooltipEl
    });
  }

  renderInput()
  {
    if(utils.isNotNull(this.inputHTML))
    {
      this.inputEl = $(this.inputHTML);
    }
    else
    {
      if(this.inputType === "textarea")
      {
        var attributes = [
          { name: "placeholder", value: this.placeholder }
        ].concat(this.inputAttributes);

        this.inputEl = $(ElementCreator.createStringElement({
          tagName: "textarea",
          classNames: [ "form-control" ].concat(this.inputClasses),
          attributes: attributes,
        }));
      }
      else if(this.inputType === "select")
      {
        var optionsEl = "";

        for(var i = 0; i < this.inputOptions.length; i++)
        {
          if(utils.isNull(this.initialValue) && i === 0)
          {
            //If there is no initial value then use the first option as current value
            this.value = this.inputOptions[i].value;
          }

          optionsEl += ElementCreator.createStringElement({
            tagName: "option",
            attributes: [
              { name: "value", value: this.inputOptions[i][this.inputOptionsValueField] }
            ],
            innerHTML: this.inputOptions[i][this.inputOptionsDisplayField]
          });
        }

        this.inputEl = $(ElementCreator.createStringElement({
          tagName: "select",
          classNames: [ "form-control" ].concat(this.inputClasses),
          attributes: this.inputAttributes,
          innerHTML: optionsEl
        }));

        if(utils.isNotNull(this.initialValue))
        {
          this.inputEl.val(this.initialValue);
        }
      }
      else if(this.inputType === "date")
      {
        var classNames = [ "form-control" ].concat(this.inputClasses);
        var attributes = [
          { name: "type", value: "text" },
          { name: "placeholder", value: this.placeholder }
        ].concat(this.inputAttributes);

        if(this.disabled)
        {
          attributes.push({ name: "disabled", value: true });
        }

        this.inputEl = $(ElementCreator.createStringElement({
          tagName: "input",
          classNames: classNames,
          attributes: attributes,
        }));

        if(utils.isNotNull(this.initialValue))
        {
          this.inputEl.val(this.initialValue);
        }

        this.inputEl.datepicker(this.dateOptions);
      }
      else if(utils.isNull(this.inputType) && (utils.isNotNull(this.displayValue) || utils.isNotNull(this.initialValue)))
      {
        var displayValue = utils.isNotNull(this.displayValue) ? this.displayValue : this.initialValue;

        this.inputEl = $(ElementCreator.createStringElement({
          classNames: [ "value-display" ],
          attributes: this.inputAttributes,
          innerHTML: displayValue
        }));
      }
      else
      {
        var classNames = [ "form-control" ].concat(this.inputClasses);
        var attributes = [
          { name: "type", value: this.inputType },
          { name: "placeholder", value: this.placeholder }
        ].concat(this.inputAttributes);

        if(this.disabled)
        {
          attributes.push({ name: "disabled", value: true });
        }

        if(this.inputType === "radio")
        {
          classNames = this.inputClasses;

          if(!utils.isNullOrEmpty(this.groupName))
          {
            attributes.push({ name: "name", value: this.groupName });
          }
        }

        if(this.inputType === "checkbox")
        {
          classNames = this.inputClasses;
        }

        this.inputEl = $(ElementCreator.createStringElement({
          tagName: "input",
          classNames: classNames,
          attributes: attributes,
        }));
      }
    }

    if(utils.isNotNull(this.inputEl) && utils.isNotNull(this.inputType))
    {
      this.inputEl.attr("id", this.inputId);

      if(utils.isNotNull(this.initialValue))
      {
        if((this.inputType === "checkbox" || this.inputType === "radio") && utils.isBoolean(this.initialValue))
        {
          this.inputEl.prop("checked", this.initialValue);
        }
        else
        {
          this.inputEl.val(this.initialValue);
        }
      }
    }
  }

  addToDOM()
  {
    if(this.inputType === "checkbox" || this.inputType === "radio")
    {
      this.formGroupEl.append(this.inputEl);
      this.formGroupEl.append(this.labelEl);
    }
    else if(this.inputType === "select")
    {
      this.formGroupEl.append(this.labelEl);
      var inputWrapper = $("<div class='input-wrapper'></div>").append($("<div class='select-wrapper'></div>").append(this.inputEl));
      this.formGroupEl.append(inputWrapper);
    }
    else if(utils.isNull(this.inputType))
    {
      this.formGroupEl.append(this.labelEl).append(this.inputEl);
    }
    else
    {
      this.formGroupEl.append(this.labelEl);
      this.formGroupEl.append($("<div class='input-wrapper'></div>").append(this.inputEl));
    }

    this.appendTo.append(this.formGroupEl);

    if(!utils.isNullOrEmpty(this.labelTooltipText))
    {
      var tooltipEl = this.formGroupEl.find(".form-label-tooltip");

      Tooltip.create({
        selector: tooltipEl,
        title: this.labelTooltipTitle,
        content: this.labelTooltipText,
        placement: this.labelTooltipPlacement
      })
    }

    if(utils.isFunction(this.afterRender))
    {
      this.afterRender(this);
    }
  }

  show()
  {
    if(utils.isNotNull(this.formGroupEl) && this.formGroupEl.length)
    {
      this.formGroupEl.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.formGroupEl) && this.formGroupEl.length)
    {
      this.formGroupEl.hide();
    }
  }
};



// WEBPACK FOOTER //
// ./app/js/templates/form-group.template.js